import { render } from "./RussianSoftwareRegistry.vue?vue&type=template&id=19d1cd80&ts=true"
import script from "./RussianSoftwareRegistry.vue?vue&type=script&lang=ts"
export * from "./RussianSoftwareRegistry.vue?vue&type=script&lang=ts"

import exportComponent from "../../../portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QImg from 'quasar/src/components/img/QImg.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../portal/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QImg,QTooltip});
